import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import { ErrorPage } from '../pages/ErrorPage';
import { HomePage } from '../pages/HomePage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { ToolsIndexPage } from '../pages/ToolsIndexPage';
import { ToolRoutePage } from '../pages/ToolRoutePage';
import { AboutPage } from '../pages/settings/AboutPage';
import { AccessibilitySettingsPage } from '../pages/settings/AccessibilitySettingsPage';
import { GeneralSettingsPage } from '../pages/settings/GeneralSettingsPage';
import { OfflineStoragePage } from '../pages/settings/OfflineStoragePage';
import { PrivacySettingsPage } from '../pages/settings/PrivacySettingsPage';
import { SettingsLayout } from '../pages/settings/SettingsLayout';
import { UpdatesSettingsPage } from '../pages/settings/UpdatesSettingsPage';
import { tools } from '../domain/tools/registry';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'tools', element: <ToolsIndexPage /> },
      ...tools.map((tool) => ({ path: tool.route.slice(1), element: <ToolRoutePage tool={tool} /> })),
      {
        path: 'settings',
        element: <SettingsLayout />,
        children: [
          { index: true, element: <GeneralSettingsPage /> },
          { path: 'offline-storage', element: <OfflineStoragePage /> },
          { path: 'privacy', element: <PrivacySettingsPage /> },
          { path: 'accessibility', element: <AccessibilitySettingsPage /> },
          { path: 'updates', element: <UpdatesSettingsPage /> },
          { path: 'about', element: <AboutPage /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
